import type { HttpPost, HttpRequest } from '@/shared/infra/http'
import { mapServerError, readServerErrorCode } from '@/shared/infra/http'
import { ProRequiredError } from '@/shared/domain'
import type {
  CreateProCrew,
  CreateProCrewParams,
  CreateProCrewResult,
} from '@/modules/auth/use-cases'

type RawCreatedCrew = {
  orgId?: string
  name?: string
  membershipId?: string
}

const PRO_REQUIRED_CODE = 'pro_required'

export class EdgeCreateProCrewRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: CreateProCrew = async (params) => {
    const body: CreateProCrewParams = { name: params.name }
    const request: HttpRequest<CreateProCrewParams> = { url: '/crews', body }
    try {
      const response = await this.httpClient.post<CreateProCrewParams, RawCreatedCrew>(request)
      return mapResponse(response, params.name)
    } catch (error) {
      if (readServerErrorCode(error) === PRO_REQUIRED_CODE) throw new ProRequiredError()
      return mapServerError(error)
    }
  }
}

function mapResponse(raw: RawCreatedCrew | null | undefined, fallbackName: string): CreateProCrewResult {
  return {
    orgId: raw?.orgId ?? '',
    orgType: 'crew',
    name: raw?.name || fallbackName,
    membershipId: raw?.membershipId ?? '',
    membershipModel: 'pro',
  }
}
